/*
 * File: CollapseActions.js
 * Project: mp-mobile-app
 *
 * Copyright (c) 2019 MacPractice, Inc. All rights reserved.
 *
 * Description: Shows the top of the chart collapse button
 */
import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import classnames from "classnames";
import { IconButton } from "@material-ui/core";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";

const styles = theme => ({
  actionContainer: {
    position: "absolute",
    right: "0px"
  },
  expand: {
    transform: "rotate(0deg)",
    transition: theme.transitions.create("transform", {
      duration: theme.transitions.duration.shortest
    })
  },
  expandOpen: {
    transform: "rotate(180deg)"
  }
});

const CollapseActions = ({ classes, expanded, onToggle }) => (
  <div className={classes.actionContainer}>
    <IconButton
      className={classnames(classes.expand, {
        [classes.expandOpen]: expanded
      })}
      onClick={onToggle}
      aria-expanded={expanded}
      aria-label="Show more"
      disableRipple
    >
      <ExpandMoreIcon />
    </IconButton>
  </div>
);

CollapseActions.propTypes = {
  classes: PropTypes.object,
  expanded: PropTypes.bool,
  onToggle: PropTypes.func
};

export default withStyles(styles)(CollapseActions);
